<template>
  <div>
    <div>
      <el-form
        :key="formData.applicantCertificateType"
        ref="ruleForm"
        :model="formData"
        :rules="rules"
        validate-on-rule-change
        label-width="190px"
        class="repayment-apply-form"
      >
        <el-row>
          <el-form-item label="申请人：">
            {{ userInfo.realName }}
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="身份证件：" prop="applicantCertificateNumber">
            <div>
              <el-select v-model="formData.applicantCertificateType" placeholder="请选择" style="width: 200px">
                <el-option
                  v-for="item in applicantCertificateTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                v-model="formData.applicantCertificateNumber"
                placeholder="请输入证件号"
                style="width: 200px"
              ></el-input>
            </div>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="证件复印件：" prop="applicantCertificatePath">
            <div class="flex">
              <eui-upload
                ref="euiUpload"
                key-name="applicantCertificatePath"
                :file-list="fileList"
                :action="uploadPayCenterFile"
                :private-upload="privateUpload"
                :headers="headers"
                :show-file-list="true"
                accept=".jpg,.png"
                single
                text="上传复印件"
                tip="请上传清晰的扫描或复印件，限≤2mb，jpg、png格式。"
                @handleSuccess="uploadSuccess"
              ></eui-upload>
            </div>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="产融还款专户开户授权书：" prop="authorizationCertificationPath">
            <div>1.下载协议模板：</div>
            <div style="margin-top: -10px" class="gray-color">
              <span v-debounce="downloadTemplate" style="color: #0064c8; cursor: pointer">
                点击下载《产融还款专户开户授权书》
              </span>
              下载后填写相关信息，申请人签字、加盖公章，并扫描后上传
            </div>
            <div>2.上传协议扫描件：</div>
            <div class="flex">
              <eui-upload
                ref="euiUploadTwo"
                :file-list="fileArr"
                :action="uploadPayCenterFile"
                :private-upload="privateUpload"
                :headers="headers"
                :show-file-list="true"
                single
                accept=".jpg,.png"
                text="上传文件"
                :picure-width="200"
                tip="请上传清晰的扫描或复印件并加盖公司公章（红色）。限≤2mb，jpg、png格式"
                @handleSuccess="uploadSuccess"
              ></eui-upload>
            </div>
          </el-form-item>
        </el-row>
      </el-form>
      <div class="flex-c">
        <eui-btn type="secondary" @click="toBack">取 消</eui-btn>
        <eui-btn v-debounce="handleSubmit" type="primary">提 交</eui-btn>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/modules/projectA/api/pay/index';
import utils from '../../../utils/utils';
import { epecToken } from '../../../utils/globalData';
import { idCardValidity } from '../../../utils/verification';

export default {
  name: 'StepOne',
  props: {
    reSubmitBtn: Boolean,
    applyId: String,
    pageFrom: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      nextStage: null,
      uploadPayCenterFile: api.uploadPayCenterFile,
      fileList: [],
      fileArr: [],
      headers: epecToken,
      // 私有仓库得地址
      privateUpload: {
        keyName: 'filePath',
        url: api.getSupplierLicenceUrl,
        method: 'get',
      },
      showImgViewer: true,
      reUploadFlag: false, // 是否重新上传
      formData: {
        applicantCertificateName: '', // 申请人证件复印件名
        applicantCertificateNumber: '', // 申请人证件复印件号码
        applicantCertificatePath: '', // 申请人证件复印件路径
        applicantCertificateType: 0, // 申请人证件复印件类型
        authorizationCertificationName: '', // 产融专户开户授权书名称
        authorizationCertificationPath: '', // 产融专户开户授权书路径
      },
      rules: {
        applicantCertificateType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
        applicantCertificateNumber: [
          { required: true, message: '请输入证件号码', trigger: 'change' },
          { required: true, validator: idCardValidity, trigger: 'change' },
        ],
        applicantCertificatePath: [{ required: true, message: '请上传证件复印件', trigger: 'change' }],
        authorizationCertificationPath: [
          {
            required: true,
            message: '请上传产融还款专户开户授权书',
            trigger: 'change',
          },
        ],
      },
      input: '',
      value: '',
      options: [],
      userInfo: {},
      handleFlag: '',
      applicantCertificateTypeList: [
        { value: 0, label: '居民身份证' },
        { value: 1, label: '武装警察身份证' },
        { value: 2, label: '护照' },
        { value: 3, label: '军人身份证' },
        { value: 4, label: '港澳居民往来内地通行证' },
        { value: 5, label: '台湾居民往来大陆通行证' },
        { value: 6, label: '户口簿' },
        { value: 7, label: '临时居民身份证' },
      ],
    };
  },
  watch: {
    // 区分第一次 提交和 之后 的 修改 false:提交，true 修改
    reSubmitBtn: {
      immediate: true,
      deep: true,
      handler(newval) {
        if (newval) {
          this.handleFlag = 'second';
          this.financeAccountApplyDetail();
        }
      },
    },
    'formData.applicantCertificateType': function (val) {
      if (val) {
        this.rules.applicantCertificateNumber[1].required = false;
        this.rules.applicantCertificateNumber[1].validator = '';
      } else {
        this.rules.applicantCertificateNumber[1].required = true;
        this.rules.applicantCertificateNumber[1].validator = idCardValidity;
      }
    },
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('USERINFO'));
  },
  methods: {
    uploadSuccess(response, file, fileList) {
      this.reUploadFlag = true;
      // console.log(response, file, fileList,'上传的返回')
    },
    toBack() {
      if (this.pageFrom) {
        this.$emit('closePage');
      } else if (this.reSubmitBtn) {
        // 再次提交
        this.$emit('changeActive', 3);
      } else {
        // 首次提交
        this.$router.push({ path: '/repaymentAccountMgt' });
      }
    },
    // 提交
    // 返回的 result.put("payCenterFileName", fileName);  result.put("ossUrl", ossUrl);
    // 上传附件多返回两字段：ossUrl 完整的oss连接，不用再调接口获取附件的完整地址了。
    handleSubmit() {
      // if (this.reUploadFlag) {
      this.$refs.euiUpload.getFileList((list) => {
        this.formData.applicantCertificatePath = list && list.length > 0 ? list[0].url : '';
        this.formData.applicantCertificateName = list && list.length > 0 ? list[0].name : '';
      });

      this.$refs.euiUploadTwo.getFileList((list) => {
        this.formData.authorizationCertificationName = list && list.length > 0 ? list[0].name : '';
        this.formData.authorizationCertificationPath = list && list.length > 0 ? list[0].url : '';
      });
      // }

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.financeAccountApply();
        }
      });
    },
    async financeAccountApply() {
      const res = await api.financeAccountApply(this.formData);
      if (res.success) {
        if (this.pageFrom) {
          this.$emit('closePage');
        } else {
          this.$emit('changeActive', 2);
        }
      }
    },
    // 下载模板
    async downloadTemplate() {
      if (process.env.NODE_ENV === 'production') {
        window.open(
          'https://prod-epec.oss-cn-beijing.aliyuncs.com/staticFiles/%E6%98%93%E6%B4%BE%E5%AE%A2%E8%BF%98%E6%AC%BE%E4%B8%93%E6%88%B7%E6%8E%88%E6%9D%83%E4%B9%A6%E6%A8%A1%E6%9D%BF.doc'
        );
      } else {
        window.open(
          'https://uatd-epec.oss-cn-beijing.aliyuncs.com/staticFiles/%E6%98%93%E6%B4%BE%E5%AE%A2%E8%BF%98%E6%AC%BE%E4%B8%93%E6%88%B7%E6%8E%88%E6%9D%83%E4%B9%A6%E6%A8%A1%E6%9D%BF.doc'
        );
      }
    },
    async paymentGetSupplierLicence(file, flag) {
      const res = await api.getPayCenterFile({ filePath: file.attachPath });
      if (res.success) {
        if (flag === 'first') {
          this.fileList.push({ name: file.attachName, url: file.attachPath });
          // this.formData.applicantCertificatePath = file.attachPath;
          this.formData.applicantCertificateNumber = file.certificateNo;
          this.formData.applicantCertificateName = file.attachName;
        } else {
          this.fileArr.push({ name: file.attachName, url: file.attachPath });
          // this.formData.authorizationCertificationPath = file.attachPath;
          this.formData.authorizationCertificationName = file.attachName;
        }
      }
    },
    // 之后 的 修改 回显第一次的值
    async financeAccountApplyDetail() {
      const res = await api.financeAccountApplyDetail({
        applyId: this.applyId,
      });
      if (res.success) {
        this.paymentGetSupplierLicence(res.data.applicantAttach, 'first');
        this.paymentGetSupplierLicence(res.data.authorizationCertificationAttach, 'second');

        // this.fileList.push(res.data.applicantAttach.attachPath);
        // this.fileArr.push(res.data.authorizationCertificationAttach.attachPath);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.repayment-apply-title {
  color: #333;
  font-size: 16px;
}
.repayment-apply-form {
  margin-left: 34px;
}
.gray-color {
  color: #999;
}
</style>
